import { C_ACTION } from '../constans';

export const addStaff = data => ({
  type: C_ACTION.ADD_STAFF,
  data,
});


export const addOneStaff = user => ({
  type: C_ACTION.ADD_ONE_STAFF,
  user,
});

export const changeStaff = (login, user) => ({
  type: C_ACTION.CHANGE_STAFF,
  login,
  user,
});

export const deleteStaff = () => ({
  type: C_ACTION.DELETE_STAFF,
});
